export default "ui-slideview-detail{display:block}\n";